import styled from 'styled-components';
import Column from '@sdk/components/ui/spacing/Column';
import Row from '@sdk/components/ui/spacing/Row';
import Text16 from '@sdk/components/ui/typography/Text16';
import { SpacingType } from '@sdk/components/ui/spacing/SpacingStyle';

export const Table = styled.table`
  width: 100%;
  border-spacing: 1px;
  border-collapse: separate;
  table-layout: fixed;
  background: ${({ theme }) => theme.colors.separatorOnWhite};
  box-shadow:
    0 0 0 1px inset ${({ theme }) => theme.colors.bodyBg},
    0 2px 8px ${({ theme }) => theme.colors.boxShadow};
`;

export const TableCell = styled.td<{ middle?: boolean }>`
  background: white;
  vertical-align: ${({ middle }) => (middle ? 'middle' : 'top')};
`;

export const PriceDisplay = styled(Text16)`
  line-height: 18px;
  margin-right: 5px;
`;

export const CheckmarkWithText = styled(Row)<{ center?: boolean } & SpacingType>`
  align-items: center;
  ${({ center }) => (center ? 'align-self: center;' : '')};
`;

export const BillingSectionColumn = styled(Column)`
  padding: 40px;
`;

export const PlanStatusLabel = styled(Column)`
  margin-left: 10px;
  left: 100%;
  top: -4px;
  position: absolute;
  white-space: nowrap;
`;

export const PlanTitle = styled(Row)`
  position: relative;
  display: inline-block;
`;

export const PlanTitleInfo = styled(Row)`
  position: relative;
  display: inline-block;
  color: ${({ theme }) => theme.colors.iconGray};
`;

export const TrialButtonWrapper = styled(Column)`
  margin-left: auto;
`;

export const TrialStartRow = styled(Row)`
  border-top: 1px solid ${({ theme }) => theme.colors.separatorOnWhite};
  border-bottom: 1px solid ${({ theme }) => theme.colors.separatorOnWhite};
`;

export const SwitchHeader = styled(Column)`
  width: 100%;
  align-items: center;
  padding: 40px 0px 30px;
`;

export const SwitchWrapper = styled(Row)`
  width: 100%;
  gap: 10px;
  justify-content: center;
`;

export const DiscountWrapper = styled(Column)`
  align-items: end;
  padding-right: 395px;
  margin-top: -15px;
  padding-bottom: 30px;
`;

export const ArrowWrapper = styled(Row)`
  margin-right: 45px;
  margin-top: -10px;
`;
